export enum PERSONAL_LOAN_PURPOSE {
  DEBT_CONSOLIDATION = 1,
  CAR = 2,
  HOLIDAY = 3,
  WEDDING = 4,
  REPAIRS = 5,
  MOVING_COSTS = 6,
  RENTAL_BOND = 7,
  PAY_BILLS = 8,
  SOLAR_BATTERY = 9,
  MEDICAL = 10,
  LEGAL_PROFESSIONAL_SERVICES = 11,
  BOAT = 12,
  MOTORBIKE = 13,
  FUNERAL_EXPENSES = 14,
  BUSINESS = 15,
  INVESTMENT = 16,
  PERSONAL_INCOME_TAX = 17,
  OTHER = 18,
  PAY_FEES = 19,
  HOME_IMPROVEMENTS = 20,
  FUNERAL_SERVICES = 21,
}

export const personalLoanPurposeMap = {
  [PERSONAL_LOAN_PURPOSE.DEBT_CONSOLIDATION]: 'Debt Consolidation',
  [PERSONAL_LOAN_PURPOSE.CAR]: 'Car',
  [PERSONAL_LOAN_PURPOSE.HOME_IMPROVEMENTS]: 'Home Improvements',
  [PERSONAL_LOAN_PURPOSE.HOLIDAY]: 'Holiday',
  [PERSONAL_LOAN_PURPOSE.WEDDING]: 'Wedding',
  [PERSONAL_LOAN_PURPOSE.REPAIRS]: 'Repairs',
  [PERSONAL_LOAN_PURPOSE.MOVING_COSTS]: 'Moving Costs',
  [PERSONAL_LOAN_PURPOSE.RENTAL_BOND]: 'Rental Bond',
  [PERSONAL_LOAN_PURPOSE.PAY_BILLS]: 'Pay Utility Bills',
  [PERSONAL_LOAN_PURPOSE.PAY_FEES]: 'Pay Fees',
  [PERSONAL_LOAN_PURPOSE.SOLAR_BATTERY]: 'Solar / Battery',
  [PERSONAL_LOAN_PURPOSE.MEDICAL]: 'Medical',
  [PERSONAL_LOAN_PURPOSE.LEGAL_PROFESSIONAL_SERVICES]: 'Legal / Professional Services',
  [PERSONAL_LOAN_PURPOSE.BOAT]: 'Boat',
  [PERSONAL_LOAN_PURPOSE.MOTORBIKE]: 'Motorbike',
  [PERSONAL_LOAN_PURPOSE.FUNERAL_EXPENSES]: 'Funeral Expenses',
  [PERSONAL_LOAN_PURPOSE.FUNERAL_SERVICES]: 'Funeral Services',
  [PERSONAL_LOAN_PURPOSE.BUSINESS]: 'Business',
  [PERSONAL_LOAN_PURPOSE.INVESTMENT]: 'Investment',
  [PERSONAL_LOAN_PURPOSE.PERSONAL_INCOME_TAX]: 'Personal Income Tax',
  [PERSONAL_LOAN_PURPOSE.OTHER]: 'Other',
}

export const personalLoanPurposeSwappedMap = {
  'Debt Consolidation': PERSONAL_LOAN_PURPOSE.DEBT_CONSOLIDATION,
  Car: PERSONAL_LOAN_PURPOSE.CAR,
  Holiday: PERSONAL_LOAN_PURPOSE.HOLIDAY,
  Wedding: PERSONAL_LOAN_PURPOSE.WEDDING,
  Repairs: PERSONAL_LOAN_PURPOSE.REPAIRS,
  'Moving Costs': PERSONAL_LOAN_PURPOSE.MOVING_COSTS,
  'Rental Bond': PERSONAL_LOAN_PURPOSE.RENTAL_BOND,
  'Pay Bills': PERSONAL_LOAN_PURPOSE.PAY_BILLS,
  'Solar / Battery': PERSONAL_LOAN_PURPOSE.SOLAR_BATTERY,
  Medical: PERSONAL_LOAN_PURPOSE.MEDICAL,
  'Legal / Professional Services': PERSONAL_LOAN_PURPOSE.LEGAL_PROFESSIONAL_SERVICES,
  Boat: PERSONAL_LOAN_PURPOSE.BOAT,
  Motorbike: PERSONAL_LOAN_PURPOSE.MOTORBIKE,
  'Funeral Expenses': PERSONAL_LOAN_PURPOSE.FUNERAL_EXPENSES,
  Business: PERSONAL_LOAN_PURPOSE.BUSINESS,
  Investment: PERSONAL_LOAN_PURPOSE.INVESTMENT,
  'Personal Income Tax': PERSONAL_LOAN_PURPOSE.PERSONAL_INCOME_TAX,
  Other: PERSONAL_LOAN_PURPOSE.OTHER,
  'Pay Utility Bills': PERSONAL_LOAN_PURPOSE.PAY_BILLS,
  'Pay Fees': PERSONAL_LOAN_PURPOSE.PAY_FEES,
  'Home Improvements': PERSONAL_LOAN_PURPOSE.HOME_IMPROVEMENTS,
  'Funeral Services': PERSONAL_LOAN_PURPOSE.FUNERAL_SERVICES,
}

export const personalLoanPurposePrefillMap = {
  debtConsolidation: PERSONAL_LOAN_PURPOSE.DEBT_CONSOLIDATION,
  car: PERSONAL_LOAN_PURPOSE.CAR,
  holiday: PERSONAL_LOAN_PURPOSE.HOLIDAY,
  wedding: PERSONAL_LOAN_PURPOSE.WEDDING,
  repairs: PERSONAL_LOAN_PURPOSE.REPAIRS,
  movingCosts: PERSONAL_LOAN_PURPOSE.MOVING_COSTS,
  rentalBond: PERSONAL_LOAN_PURPOSE.RENTAL_BOND,
  payBills: PERSONAL_LOAN_PURPOSE.PAY_BILLS,
  solarBattery: PERSONAL_LOAN_PURPOSE.SOLAR_BATTERY,
  medical: PERSONAL_LOAN_PURPOSE.MEDICAL,
  legalProfessionalServices: PERSONAL_LOAN_PURPOSE.LEGAL_PROFESSIONAL_SERVICES,
  boat: PERSONAL_LOAN_PURPOSE.BOAT,
  motorbike: PERSONAL_LOAN_PURPOSE.MOTORBIKE,
  funeralExpenses: PERSONAL_LOAN_PURPOSE.FUNERAL_EXPENSES,
  business: PERSONAL_LOAN_PURPOSE.BUSINESS,
  investment: PERSONAL_LOAN_PURPOSE.INVESTMENT,
  personalIncomeTax: PERSONAL_LOAN_PURPOSE.PERSONAL_INCOME_TAX,
  other: PERSONAL_LOAN_PURPOSE.OTHER,
  payUtilityBills: PERSONAL_LOAN_PURPOSE.PAY_BILLS,
  payFees: PERSONAL_LOAN_PURPOSE.PAY_FEES,
  homeImprovements: PERSONAL_LOAN_PURPOSE.HOME_IMPROVEMENTS,
  funeralServices: PERSONAL_LOAN_PURPOSE.FUNERAL_SERVICES,
}
